module.exports = __webpack_public_path__ + "static/img/menu-low-code.f7e29af.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/menu-low-code.jpg
// module id = ufE1
// module chunks = 1